import { createFileRoute, Outlet } from '@tanstack/react-router'
import { guardJeridSchoolAdminOnly } from '../lib/auth/routeGuards'
import JeridSchoolAdminLayout from '@/components/jeridSchoolAdminPage/JeridSchoolAdminLayout'

export const Route = createFileRoute('/jerid_school_admin')({
  beforeLoad: guardJeridSchoolAdminOnly,
  component: () => (
    <JeridSchoolAdminLayout>
      <Outlet />
    </JeridSchoolAdminLayout>
  ),
})